import { render, staticRenderFns } from "./GerbFlag.vue?vue&type=template&id=2a7da601&"
import script from "./GerbFlag.vue?vue&type=script&lang=js&"
export * from "./GerbFlag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports